import React from 'react';

import { Divider, Group, Stack, Text } from '@mantine/core';
import { AthleteKiloClassWithAthleteAndWaitlistOrder, KiloClassRetrieve } from 'types';
import { LastCreditAlertContent } from 'utils/last-credit-alert';

import ReservedAndCheckedInAthlete from './components/ReservedAndCheckedInAthlete';

interface IReservedAndCheckedInAthletesProps {
  athleteKiloClasses: AthleteKiloClassWithAthleteAndWaitlistOrder[];
  permission?: boolean;
  kiloClass: KiloClassRetrieve;
  setLastCreditAlert: React.Dispatch<React.SetStateAction<LastCreditAlertContent | null>>;
}

const ReservedAndCheckedInAthletes = ({
  athleteKiloClasses,
  kiloClass,
  permission = true,
  setLastCreditAlert,
}: IReservedAndCheckedInAthletesProps): JSX.Element => {
  if (athleteKiloClasses.length) {
    return (
      <Stack spacing={0}>
        {athleteKiloClasses.map((akc, index) => {
          return (
            <ReservedAndCheckedInAthlete
              setLastCreditAlert={setLastCreditAlert}
              athleteKiloClass={akc}
              kiloClass={kiloClass}
              permission={permission}
              index={index}
              key={index}
            />
          );
        })}
        <Divider />
      </Stack>
    );
  }
  return (
    <Group position='center'>
      <Text color='dimmed'>No athletes to display</Text>
    </Group>
  );
};

export default ReservedAndCheckedInAthletes;
